export default __webpack_public_path__ + "static/media/624.9f83ade4.png";